import Swal, { SweetAlertResult } from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
    AlertErrorIcon,
    AlertInfoIcon,
    AlertWarningIcon
} from '../components/icons';
import { UnsupportedReason } from '../types';
import './swal.css';

//TODO - would like to update this function so we can pass colorMode into it
//TODO - would like to merge swal.css with index.css styling
function SwalFireWithCustomStyle(props: any): Promise<SweetAlertResult<any>> {

    return withReactContent(Swal).fire({...props,
        iconHtml:
            props.icon === 'warning' ? (
                <AlertWarningIcon />
            ) : props.icon === 'info' ? (
                <AlertInfoIcon />
            ) : props.icon === 'error' ?  (
                <AlertErrorIcon />
            ) : null,
        customClass: props.icon ? '' : 'no-icon-padding'
    });
}

export const unsupportedBookSwal = (
    bookName: string,
    stateLabel: string | undefined
): Promise<SweetAlertResult<any>> => {
    const unsupportedLocation = Boolean(stateLabel)
        ? `in ${stateLabel}`
        : 'outside of the U.S.A.';
    return SwalFireWithCustomStyle({
        titleText: `We do not support ${bookName} in ${unsupportedLocation}`,
        icon:  'warning'
	});
};

export const comingSoonBookSwal = (
    bookName: string,
    stateLabel: string | undefined
): Promise<SweetAlertResult<any>> => {
    const comingSoonLocation = Boolean(stateLabel)
        ? `in ${stateLabel}`
        : 'outside of the U.S.A.';
    return SwalFireWithCustomStyle({
        titleText: `We do not support ${bookName} in ${comingSoonLocation}, but we will soon`,
        icon:  'warning'
	});
};

export const inactiveBookSwal = (
    bookName: string
): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: `${bookName} is currently down for maintenance. Try again later.`,
        icon:  'warning'
	});
};

export const noBookForLocationSwal = (): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: `There are currently no available sportsbook integrations for your location`,
        icon:  'warning'
	});
};

export const inactiveBookRegionSwal = (
    detail: string
): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
		titleText: detail,
		icon:  'error'
	});
};

export const badCredsResponseSwal = (): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: `Not a valid username password combination`,
        icon:  'error'
	});
};

export const errorResponseSwal = (
    bookName: string
): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: `There was an unexpected issue linking your account. Please log in to ${bookName} to ensure your account and the sportsbook website are active and then try again.`,
        icon:  'error'
	});
};

export const bookLoginTimeoutSwal = () => {
    return SwalFireWithCustomStyle({
        titleText: `Your request has timed out. Please try again later.`,
        icon:  'error'
	});
};

export const rateLimitedSwal = (): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: `This account was just refreshed, try again in 1 minute`,
        icon:  'warning'
	});
};

export const bookLogin2FAResponseSwal = (
    userName: string,
    bookName: string
) => {
    return SwalFireWithCustomStyle({
        titleText: `Currently ${userName} does not support two-factor-authentication for ${bookName} in this region.`,
        icon:  'error'
	});
};

export const bookLoginBadOTPResponseSwal = (bookName: string) => {
    return SwalFireWithCustomStyle({
        titleText: `We could not verify your account with ${bookName}. Please try again and ensure you have entered the correct 2FA code.`,
        icon:  'error'
	});
};

export const bookLoginNoOTPResponseSwal = (bookName: string) => {
    return SwalFireWithCustomStyle({
        titleText: `You have enabled two-factor authentication on ${bookName}. Please relink your account and enter a One Time Password.`,
        icon:  'warning'
	});
};

export const bookLoginActionResponseSwal = (bookName: string) => {
    return SwalFireWithCustomStyle({
        titleText: `We could not verify your account. Please log in to ${bookName} on desktop and take any action needed.`,
        icon:  'error'
	});
};

export const bookLoginTOSResponseSwal = (bookName: string) => {
    return SwalFireWithCustomStyle({
        titleText: `We could not verify your account. Please log in to ${bookName} and accept the Terms of Service.`,
        icon:  'error'
	});
};

export const bookLoginLocationResponseSwal = (bookName: string) => {
    return SwalFireWithCustomStyle({
        titleText: `We could not verify your account. Please check your email for a message from ${bookName} and confirm this login attempt, then try again.`,
        icon:  'error'
    });
};

export const otpPromptSwal = (bookName: string) => {
    return SwalFireWithCustomStyle({
        titleText: 'Two-Factor Authentication',
        text: `Please enter the ${bookName} 2FA code you have received`,
        input: 'text',
        icon: 'info',
        inputValidator: (value: string) => {
            if (!value) {
                return 'Please enter a 2FA code';
            } else return null;
        },
        showCancelButton: true,
    });
};

export const bookLoginFormValidationSwal = (
    validationType: 'username' | 'password'
): Promise<SweetAlertResult<any>> => {
    let popupMessage = '';
    switch (validationType) {
        case 'username':
            popupMessage = 'Please enter your login username or email.';
            break;
        case 'password':
            popupMessage = 'Please enter your password.';
            break;
    }
    return SwalFireWithCustomStyle({
        titleText: popupMessage,
        icon:  'error'
    });
};

export const unverifiedBookLoginTicketCreatedSwal = (): Promise<
    SweetAlertResult<any>
> => {
    return SwalFireWithCustomStyle({
        titleText:'Your ticket you has been created and support will contact you shortly',
        //icon:  'success' //TODO - Need Success SVG and use success case here
    });
};

// TODO: add error responses.messages from zendesk
export const unverifiedBookLoginTicketErrorSwal = (): Promise<
    SweetAlertResult<any>
> => {
    return SwalFireWithCustomStyle({
        titleText:'Couldn’t submit your request.  Make sure you entered a valid email or try again later.',
        icon: 'error'
    });
};

export const incorrectBookLoginEmailSwal = (): Promise<
    SweetAlertResult<any>
> => {
    return SwalFireWithCustomStyle({
        titleText:'Please enter a valid email',
        icon: 'error'
    });
};

const deleteReasonOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            bookChurn: 'I no longer bet at this book',
            unlinking: 'I had trouble keeping my account linked',
            badData: "My bet data didn't come through",
            other: 'Other',
        });
    }, 1000);
});

export const confirmDeleteAccountSwal = (): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: 'Why do you want to remove this account?',
        input: 'select',
        inputOptions: deleteReasonOptions,
        inputPlaceholder: 'Select a reason',
        icon: 'warning',
        showCancelButton: true,
        inputValidator: (value: string) => {
            if (!value) {
                return 'Please select the reason you are removing this account';
            } else return null;
        },
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Remove',
    });
};

export const selectRegionSwal = (regionDict: {
    [key: string]: string;
}): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        titleText: 'Please select the region you are betting from',
        input: 'select',
        inputOptions: regionDict,
        inputPlaceholder: 'Select a region',
        showCancelButton: false,
        inputValidator: (value: string) => {
            if (!value) {
                return 'Please select a region';
            } else return null;
        },
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Confirm',
        allowOutsideClick: false,
    });
};

export const DKConsentSwal = (
    userName: string | null
): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        title: 'Confirmation',
        titleText: `By continuing, you grant access to your betting history on DraftKings every time you visit your
         ${userName} account. You can revoke access at any time.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
    });
};

export const MGStrongAuthSwal = (): Promise<SweetAlertResult<any>> => {
    return SwalFireWithCustomStyle({
        title: 'BetMGM Strong Authentication',
        titleText: `If you have Strong Authentication enabled for MGM, you must deactivate it in order to continue to sync bets without re-entering your credentials.`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
    });
}

export const unsupportedReasonSwal = (
    unsupportedReason: UnsupportedReason,
    bookName: string,
    userName: string
): Promise<SweetAlertResult<any>> => {
    let text = '';
    switch (unsupportedReason) {
        case UnsupportedReason.noWeb:
            text = `${bookName} syncing is not currently available on web, but will be soon!`;
            break;
        case UnsupportedReason.MobileOnly:
            text = `In order to link your ${bookName} account you must
            use the ${userName} mobile app`;
            break;
        case UnsupportedReason.Android:
            text = `Unfortunately we are currently unable to link ${bookName} accounts
            on Android devices`;
            break;
        case UnsupportedReason.iOS:
            text = `Unfortunately we are currently unable to link ${bookName} accounts
            on iOS devices`;
            break;
        case UnsupportedReason.MobileVersion:
            text = `We are unable to link ${bookName} accounts on your device. Please make sure
            that you have downloaded the latest version of the ${userName} app`;
            break;
        case UnsupportedReason.Maintainence:
            text = `${bookName} is currently down for maintenance in your region.`;
            break;
        case UnsupportedReason.ComingSoon:
            text = `${bookName} is not currently available in your region but is coming soon!`;
            break;
        case UnsupportedReason.UserAccountInactive:
            text = `${userName} does not support ${bookName} in this region`
            break;
        default:
            break;
    }

    return SwalFireWithCustomStyle({
        titleText: text,
        icon:  'error',
    });
};

export const downloadExtensionSwal = (): Promise<SweetAlertResult<any>> => {
    let popupText = `Download the SharpSports Browser Extension to Complete the Link. Available on Chrome Browser Only`;
    return SwalFireWithCustomStyle({
        icon: 'info',
        titleText: popupText,
        showCancelButton: true,
        confirmButtonText: 'Download Extension',
        cancelButtonText: 'Cancel',
    });
};

export default {
    unsupportedBook: unsupportedBookSwal,
    inactiveBook: inactiveBookSwal,
    inactiveBookRegion: inactiveBookRegionSwal,
    badCredsResponseSwal: badCredsResponseSwal,
    bookLoginFormValidation: bookLoginFormValidationSwal,
    bookLoginTimeout: bookLoginTimeoutSwal,
    bookLoginActionResponse: bookLoginActionResponseSwal,
    comingSoon: comingSoonBookSwal,
    unverifiedBookLoginTicketCreated: unverifiedBookLoginTicketCreatedSwal,
    unverifiedBookLoginTicketError: unverifiedBookLoginTicketErrorSwal,
    incorrectBookLoginEmail: incorrectBookLoginEmailSwal,
    rateLimited: rateLimitedSwal,
    deleteAccount: confirmDeleteAccountSwal,
    bookLogin2FAResponse: bookLogin2FAResponseSwal,
    bookLoginBadOTPResponseSwal: bookLoginBadOTPResponseSwal,
    bookLoginNoOTPResponseSwal: bookLoginNoOTPResponseSwal,
    bookLoginTOSResponse: bookLoginTOSResponseSwal,
    bookLoginLocationResponse: bookLoginLocationResponseSwal,
    errorResponseSwal: errorResponseSwal,
    selectRegionSwal: selectRegionSwal,
    unsupportedReasonSwal: unsupportedReasonSwal,
    DKConsentSwal: DKConsentSwal,
    noBookForLocationSwal: noBookForLocationSwal,
    downloadExtensionSwal: downloadExtensionSwal,
    MGStrongAuthSwal: MGStrongAuthSwal,
};
